function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#4A4A4A",
      fillOpacity: 1
    },
    d: "M 10.753906 32.828125 L 19.585938 32.828125 L 19.585938 29.886719 L 10.753906 29.886719 Z M 10.753906 15.171875 L 10.753906 18.113281 L 37.246094 18.113281 L 37.246094 15.171875 Z M 10.753906 25.472656 L 28.414062 25.472656 L 28.414062 22.527344 L 10.753906 22.527344 Z M 10.753906 25.472656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortby);
export default __webpack_public_path__ + "static/media/Sort by.53983ecf15c95da91b165678cfefc07d.svg";
export { ForwardRef as ReactComponent };